export default {
    API_URL: "https://pombeebee.com",
    SERVER_URL: "https://pombeebee.com",
    SOCKET_URL: "http://websocket.zombeebee.com",
    AUTH_BACKEND: 'Blubberbee'
}